import { Box, useColorModeValue } from '@ecoinvent/ui';

import { QuestionnaireStep } from '../types';

interface ProgressBarProps {
  currentStep: QuestionnaireStep;
  totalSteps: number;
}

const ProgressBar = ({ currentStep, totalSteps }: ProgressBarProps) => {
  const activeBg = useColorModeValue('gray.800', 'white');
  const inactiveBg = useColorModeValue('gray.200', 'gray.600');

  return (
    <Box
      display="flex"
      gap="10px"
      justifyContent="center"
      w="100%"
      py={2}
      role="progressbar"
      aria-valuenow={currentStep}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-label={`Step ${currentStep} of ${totalSteps}`}
    >
      {Array.from({ length: totalSteps }, (_, i) => (
        <Box key={i} h="4px" w="80px" borderRadius="full" bg={i < currentStep ? activeBg : inactiveBg} />
      ))}
    </Box>
  );
};

export default ProgressBar;
